module.exports = __webpack_public_path__ + "static/img/book_1.b870a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/book_1.png
// module id = TP0Q
// module chunks = 1